import React from 'react';
import { portfolioApps } from '../data/portfolioData';

const sortedApps = [...portfolioApps].sort((a, b) => a.name.localeCompare(b.name));

const Portfolio = () => (
  <div className="portfolio-page">
    <div className="container">
      <div className="section__header portfolio-page__header">
        <span className="section__tag">Portfolio</span>
        <h1 className="section__title">
          Built, shipped and <span className="gradient-text">operated by us</span>
        </h1>
        <p className="section__subtitle">
          Twenty production apps designed, engineered and run end-to-end by Wolf
          Technologies — native iOS and web, on serverless AWS architecture with
          AI woven throughout. Every one is live: try them in your browser.
        </p>
      </div>

      <div className="portfolio__grid">
        {sortedApps.map((app) => (
          <a
            key={app.slug}
            href={app.url}
            target="_blank"
            rel="noopener noreferrer"
            className="portfolio__card"
          >
            <div className="portfolio__card-top">
              <img
                src={app.icon}
                alt={`${app.name} icon`}
                className="portfolio__card-icon"
                loading="lazy"
              />
              <div>
                <h3 className="portfolio__card-title">{app.name}</h3>
                <span className="portfolio__card-category">{app.category}</span>
              </div>
            </div>
            <p className="portfolio__card-blurb">{app.blurb}</p>
            <span className="portfolio__card-link">
              Open the app
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M7 17L17 7M7 7h10v10" />
              </svg>
            </span>
          </a>
        ))}
      </div>

      <div className="portfolio__cta">
        <p>Want an app like these — or something entirely new?</p>
        <a href="/#contact" className="btn btn--primary">Start a project</a>
      </div>
    </div>
  </div>
);

export default Portfolio;
